import { useCallback } from 'react'
import type { CanvasNode } from '../application/workflow-canvas-layout'
import { activeWorkflow$, canvasPositions$, saveCanvasPositions } from '../store'

const useCanvasPositions = () => {
	const persistPositions = useCallback((nodes: CanvasNode[]) => {
		const wf = activeWorkflow$.get()
		if (!wf) return
		const positions: Record<string, { x: number; y: number }> = {}
		for (const n of nodes) positions[n.id] = n.position
		const all = { ...canvasPositions$.get(), [wf.id]: positions }
		canvasPositions$.set(all)
		saveCanvasPositions(all)
	}, [])

	const clearPositions = useCallback(() => {
		const wf = activeWorkflow$.get()
		if (!wf) return
		const all = { ...canvasPositions$.get() }
		delete all[wf.id]
		canvasPositions$.set(all)
		saveCanvasPositions(all)
	}, [])

	const storedPositionsFor = useCallback((workflowId: string): Record<string, { x: number; y: number }> => {
		return canvasPositions$.get()[workflowId] ?? {}
	}, [])

	return { persistPositions, clearPositions, storedPositionsFor }
}

export { useCanvasPositions }
